
<template>
  <html>
    <head>
      
    </head>
    <body>
      <navbar></navbar>

      <img
        id="header-s"
        src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-s.png"
      />
      <div class="title-page-l">
    <img
          class="img-profile"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-img-user.png"
        />
        <p>พรชนก งามสม</p>
        <h1>87,636</h1>
      </div>


      <div class="row bg-white">

           
   
      </div>
      <div class="row bt" >
        <button   type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30">การสะสมคะเเนน</button>
        <button onclick="myFunction()" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-3">การเเลกคะเเนน</button>
        <a href="ShopView04" type="button" class="btn btn-accept light-color font-color btn-lg btn-block mt-3">การซื้อสินค้า/ บริการ</a>
      </div>
    </body>
  </html>

  
</template>
<script>
import Navbar from "./navbar"
export default {
name:"", 
components:{
    "navbar": Navbar
},
data() {
return {
}
 },
mounted(){
},
}
</script>
<style scoped>
@import "./Css/style.css";
.row {
  margin-right: 0px ;
  margin-left: 0px ;
}

.title-page-l {
  width: 100%;
  top: 5px;
  position: absolute;
  overflow: visible;
  text-align: left;
  font-family: Prompt Medium;
  padding-left: 15px;
}
.title-page-l h1 {
  font-size: 30px;
  color: #ffffff;
  font-family: Prompt SemiBold;
  letter-spacing: 2px;
    margin-left: 70px;
    margin-top: 20px;
}
.title-page-l p {
  font-size: 14px;
  color: #ffffff;
  margin-bottom: -20px;
  margin-left: 70px;
  text-align: left;
}
.title-page-r {
  display: table;
  top: 27px;
  position: absolute;
  overflow: visible;
  background: rgb(255, 255, 255, 0.3);
  border-radius: 30px;
  width: 85px;
  left: 275px;
  height: 31px;
}
.title-page-r p {
  color: #ffffff;
  padding-top: 10px;
}
.bg-white {
background: #7bc79a;
    border-radius: 10px;
    height: 250px;

    position: relative;
    overflow: visible;
    top: 90px;

    margin-right: auto;
    padding: 10px;
    display: block;
    width:90%;
 
    margin-left: auto;

}
.img-profile {
 display: block;
  margin-left: 9;
  margin-right: 9;
  width: 59px;
  height: 59px;
  float: left;
}
.name-profile {
  font-family: Prompt Medium;
  color: #ffffff;
  padding: 15px 0px 0px 15px;
   font-size: 19px;
}

h1 {
  font-size: 20px;
  margin-top: 0px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;

}
.mt-30 {
  margin-top: 99px;
  text-align: center;
}
.mt-3{
      text-align: center;
}

.bt {
top: 20px;
    border-radius: 10px;
    height: 90px;
    width: 90%;
    position: relative;
    margin-left: auto;
    overflow: visible;
    margin-right: auto;
    text-align: center;

}
.btn-accept light-color font-color {
/*background: #B50610;
border: #B50610;*/
color: #ffffff;
height: 70px;
}
</style>
